import { Users, Dumbbell, CreditCard, BookOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ManagementButtonsProps {
  gymId: string;
}

interface ManagementCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
}

const ManagementCard = ({ icon, title, description, onClick }: ManagementCardProps) => (
  <button
    onClick={onClick}
    className="flex items-start gap-3 p-3 rounded-lg bg-background/50 border border-border/50 hover:bg-background hover:border-border hover:shadow-sm transition-all text-left group"
  >
    <div className="p-2 rounded-lg bg-primary/10 text-primary group-hover:bg-primary/15 transition-colors shrink-0">
      {icon}
    </div>
    <div className="min-w-0">
      <p className="text-sm font-medium text-foreground">{title}</p>
      <p className="text-xs text-muted-foreground">{description}</p>
    </div>
  </button>
);

export const ManagementButtons = ({ gymId }: ManagementButtonsProps) => {
  const navigate = useNavigate();

  const navigationItems = [
    {
      icon: <Users className="h-4 w-4" />,
      title: "Usuarios",
      description: "Ver lista de miembros",
      onClick: () => navigate(`/total-usuarios?gym_id=${gymId}`),
    },
    {
      icon: <Dumbbell className="h-4 w-4" />,
      title: "Clases",
      description: "Gestionar clases",
      onClick: () => navigate(`/gestion-clases/${gymId}`),
    },
    {
      icon: <BookOpen className="h-4 w-4" />,
      title: "Noticias",
      description: "Publicar novedades",
      onClick: () => navigate(`/gestion-noticias/${gymId}`),
    },
    {
      icon: <CreditCard className="h-4 w-4" />,
      title: "Pagos",
      description: "Ver historial de pagos",
      onClick: () => navigate(`/total-pagos?gym_id=${gymId}`),
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2">
      {navigationItems.map((item, index) => (
        <ManagementCard key={index} {...item} />
      ))}
    </div>
  );
};
